import { render, staticRenderFns } from "./policy-accordion-basic.vue?vue&type=template&id=2b841ac2&scoped=true&"
import script from "./policy-accordion-basic.vue?vue&type=script&lang=js&"
export * from "./policy-accordion-basic.vue?vue&type=script&lang=js&"
import style0 from "./policy-accordion-basic.vue?vue&type=style&index=0&id=2b841ac2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b841ac2",
  null
  
)

export default component.exports